import moment from 'moment';
import { DEFAULT_DATE_FORMAT } from 'api/models';
import { Allocation, ResourceType } from 'api/resource-management/types';
import {
  AllocationEvent,
  TeamAllocationEvent,
  UserAllocationEvent,
} from 'components/organisms/resource-management/event-types';

export const asAllocationPayloadFromEvent = (
  event: AllocationEvent,
): Allocation => {
  const userEvent = event as UserAllocationEvent;

  if (userEvent.userId != null) {
    return {
      id: Number(event.id),
      type: ResourceType.User,
      userId: userEvent.userId,
      ...(userEvent.referenceTeamId
        ? {
            roleId: userEvent.roleId,
            referenceTeamId: userEvent.referenceTeamId,
          }
        : {}),
      overAllocations: userEvent.overAllocations,
      startDate: moment(event.startDate).format(DEFAULT_DATE_FORMAT),
      endDate: moment(event.endDate).format(DEFAULT_DATE_FORMAT),
      minutes: event.minutes,
      totalMinutes: event.totalMinutes,
      projectPhaseId: event.projectPhase?.id,
      billable: event.billable ?? false,
      projectId: event.projectId,
      medium: event.medium,
      sources: event.sources,
      projectFinancialsBudgetId: event.projectFinancialsBudgetId,
      includeSaturday: event.includeSaturday ?? false,
      includeSunday: event.includeSunday ?? false,
      // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
      fields: event.fields,
      workId: event.workId,
      workType: event.workType,
    };
  }

  const teamEvent = event as TeamAllocationEvent;

  return {
    id: Number(event.id),
    type: ResourceType.Team,
    teamId: teamEvent.teamId,
    roleId: teamEvent.roleId,
    startDate: moment(event.startDate).format(DEFAULT_DATE_FORMAT),
    endDate: moment(event.endDate).format(DEFAULT_DATE_FORMAT),
    minutes: event.minutes,
    totalMinutes: event.totalMinutes,
    projectPhaseId: event.projectPhase?.id,
    billable: event.billable ?? false,
    projectId: event.projectId,
    medium: event.medium,
    sources: event.sources,
    projectFinancialsBudgetId: event.projectFinancialsBudgetId,
    includeSaturday: event.includeSaturday ?? false,
    includeSunday: event.includeSunday ?? false,
    // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
    fields: event.fields,
    workId: event.workId,
    workType: event.workType,
  };
};
